import { createAuthClient } from "better-auth/react";

const API_BASE =
  (import.meta.env.VITE_API_URL as string | undefined) ||
  "http://localhost:8787";

export const authClient = createAuthClient({
  baseURL: API_BASE,
});
